import { Users2, Building2, Globe, FileText, Wallet, Shield } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { usePlatformMetrics } from '@/hooks/usePlatform';
import { formatNumber, formatUsd } from '@/lib/utils';

export function PlatformDashboardPage() {
  const { data, isPending } = usePlatformMetrics();

  if (isPending || !data) return <div className="text-muted-foreground">Yükleniyor…</div>;

  const cards = [
    { label: 'Kullanıcı', value: data.users, icon: Users2 },
    { label: 'Organizasyon', value: data.organizations, icon: Building2 },
    { label: 'Platform Owner', value: data.owners, icon: Shield },
    { label: 'Site', value: data.sites, icon: Globe },
    { label: 'İçerik', value: data.content, icon: FileText },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Platform Kontrol Paneli</h1>
        <p className="text-muted-foreground text-sm">Gerçek zamanlı sistem özeti.</p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {cards.map((c) => (
          <Card key={c.label}>
            <CardHeader className="pb-2">
              <CardTitle className="text-xs font-medium text-muted-foreground flex items-center gap-2">
                <c.icon className="w-3.5 h-3.5" /> {c.label}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-semibold">{formatNumber(c.value)}</div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2">
            <Wallet className="w-4 h-4" /> Bakiye Akışı
          </CardTitle>
          <CardDescription>Tüm organizasyonlar üzerinden toplam (USD).</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4 sm:grid-cols-3">
            <Metric label="Tanımlanan" value={data.credits.granted} color="text-emerald-600 dark:text-emerald-400" />
            <Metric label="Harcanan" value={data.credits.consumed} color="text-destructive" />
            <Metric label="Mevcut Bakiye" value={data.credits.outstanding_balance} color="text-primary" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

function Metric({ label, value, color }: { label: string; value: number; color: string }) {
  return (
    <div className="rounded-md border bg-muted/30 p-4">
      <div className="text-xs text-muted-foreground">{label}</div>
      <div className={`text-xl font-semibold font-mono ${color}`}>{formatUsd(value, 2)}</div>
      <div className="text-[10px] text-muted-foreground font-mono mt-0.5">{formatUsd(value, 6)}</div>
    </div>
  );
}
